export default "__VITE_ASSET__Ck7Ea9vn__"